var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sidebar-layout", {
    attrs: {
      moduleCode: _vm.moduleCode,
      subModuleCode: _vm.subModuleCode,
      containerClasses: _vm.containerClasses,
      enableHeader: _vm.enableHeader,
      enableFooter: _vm.enableFooter,
      navTopMenu: _vm.hasNavTopMenu,
      enableMainSidebar: _vm.enableMainSidebar,
      mainSidebarOnlyMobile: _vm.mainSidebarOnlyMobile,
      fixedTopMenuDashboard: _vm.fixedTopMenuDashboard,
    },
    scopedSlots: _vm._u(
      [
        !_vm.hasNavTopMenu
          ? {
              key: "aside-main-menu",
              fn: function () {
                return [_c("nav-menu-sidebar")]
              },
              proxy: true,
            }
          : null,
        {
          key: "content-top",
          fn: function () {
            return [_vm._t("content-top")]
          },
          proxy: true,
        },
        {
          key: "main",
          fn: function () {
            return [_vm._t("main")]
          },
          proxy: true,
        },
        {
          key: "aside-control",
          fn: function () {
            return [
              _vm._t("aside-control"),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm.activeDashboardPanel
                    ? _c("panel-dashboard", {
                        attrs: {
                          moduleCode: _vm.moduleCode,
                          "data-panel": "dashboard",
                          panelTitle: "Dashboard",
                          position: "right",
                          size: "small",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "bottom-control",
          fn: function () {
            return [
              _vm.swipeMenu
                ? _c("swipe-menu-map", {
                    attrs: { moduleCode: _vm.moduleCode },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }